import { useEffect, useState, useCallback } from "react";
import apiClient from "../api/apiClient";
import apiPaths from "../api/endpoints";

export interface Activity {
  documentId: string;
  title: string;
  imageUrl: string;
}

interface ActivitiesApiResponse {
  status: number;
  data: Activity[];
}

export function useGetActivities() {
  const [data, setData] = useState<Activity[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchActivities = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await apiClient.get<ActivitiesApiResponse>(apiPaths.GET_ACTIVITIES);
      setData(res.data?.data || []);
    } catch (err: any) {
      setError(
        err?.response?.data?.message || err?.message || "Failed to fetch activities"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActivities();
  }, [fetchActivities]);

  return { data, loading, error, refetch: fetchActivities };
}
